import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';


import { NgbActiveModal, NgbDateStruct, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService, DateUtils } from 'ng-jhipster';

import { Invoice, InvoiceStatus } from './invoice.model';
import { InvoicePopupService } from './invoice-popup.service';
import { InvoiceService } from './invoice.service';
import { Payment, PaymentUtilService, PaymentService } from '../payment';
import { PaymentItem, PaymentItemService } from '../payment-item';
import { Student } from '../student';
import { School, SchoolService } from '../school';
import { Tax, TaxService } from '../tax';


import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal, CRUD_ACTIONS, DateUtilities } from '../../shared/index';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BlobUtilities } from '../../shared/blob/blob-utils';

@Component({
    selector: 'jhi-invoice-dialog',
    templateUrl: './invoice-dialog.component.html'
})
export class InvoiceDialogComponent extends AbstractDialogComponent implements OnInit {

    invoice: Invoice;
    authorities: any[];
    isSaving: boolean;
    pdfUrl: SafeResourceUrl | null = null;
    toggleShowPdf: boolean = false;  // Initially hide the PDF;
    currentSchool: School;
    protected taxes: Tax[];
    protected loadingTaxes: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private invoiceService: InvoiceService,
        private paymentService: PaymentService,
        private taxService: TaxService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        private router: Router,
        principal: Principal,
        private sanitizer: DomSanitizer
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['payment', 'paymentType', 'paymentItem', 'invoice', 'invoiceStatus']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_ADVANCED_TEACHER', 'ROLE_SCHOOL-ADMIN', 'ROLE_ADMIN'];
        this.loadSchools();
        this.schoolService.findCurrent()
                              .subscribe(school => {
                                this.currentSchool = school;
                                this.loadTaxes(this.currentSchool.countryId);
                              }, e => this.onError(e));
    }

    private showPdf() {
        this.toggleShowPdf = !this.toggleShowPdf;
        this.generatePdf();
    }

    private loadTaxes(countryId: number) {
        this.taxService
            .query().subscribe(
            (res: HttpResponse<Tax[]>) => {
                this.taxes = res.body;
                this.loadingTaxes = false;
                if (this.taxes) {
                    let countryTaxes = this.taxes.filter(tax => tax.country.id === countryId);
                    this.taxes = countryTaxes.sort((a: Tax, b: Tax) =>
                                a && a.code.localeCompare(b.code));

                    // preselect the tax
                    if (this.invoice.school && this.invoice.school.defaultTaxId && this.taxes.length > 0) {
                        const defaultTax = this.taxes.find(tax => tax.id === this.invoice.school.defaultTaxId);
                        if (defaultTax) {
                            this.invoice.taxRate = defaultTax.rate; // Preselect the tax rate
                        }
                    }
                }
            },
            (res: HttpErrorResponse) => this.onError(res));

    }

    private generatePdf() {
        if (this.toggleShowPdf) {
            this.invoiceService.generatePdf(this.invoice).subscribe(
                (pdfBlob: Blob) => {
                // Create an object URL for the blob
                const pdfObjectUrl = URL.createObjectURL(pdfBlob);
                this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfObjectUrl);
                },
                (error: HttpErrorResponse) => {
                    this.onError(error);
                });
        }
    }

    openPdf(): void {
        this.invoiceService.generatePdf(this.invoice).subscribe(
            (pdfBlob: Blob) => {
                BlobUtilities.openBlobInAnotherTab(pdfBlob);
            },
            (error: HttpErrorResponse) => {
                this.onError(error);
            }
        );
    }

    dateIssuedChanged(fromDate: NgbDateStruct) {
        if (!this.invoice || !this.invoice.dateIssued || !this.currentSchool || !this.currentSchool.invoiceDueDays) {
            return;
        }

        // We set the due date based on the school
        let dateIssued: Date = new Date(this.invoice.dateIssued.year,
            this.invoice.dateIssued.month, this.invoice.dateIssued.day);
        let dueDate: Date = new Date();
        dueDate.setDate(dateIssued.getDate() + this.currentSchool.invoiceDueDays);

        this.invoice.dueDate = {
            year: dueDate.getFullYear(),
            month: dueDate.getMonth() + 1,
            day: dueDate.getDate()
        };
    }

    onTaxRateChanged(taxRate: number) {
        this.paymentService.getVirtualInvoiceForPayment(this.invoice.payment.id, taxRate)
        .subscribe(virtualInvoice => {
            // refresh only the calculated fields in the invoice shown in the screen, with the data returned by API
            this.invoice.taxRate = taxRate;
            this.invoice.taxAmount = virtualInvoice.taxAmount;
            this.invoice.subTotal = virtualInvoice.subTotal;
        });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    saveInvoice(form: NgForm) {
        if (this.invoice.id !== undefined && this.invoice.id !== null) {
            this.invoiceService.update(this.invoice)
                .subscribe((res: Invoice) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE),
                    (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.invoiceService.create(this.invoice)
                .subscribe((res: Payment) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.CREATE),
                    (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Invoice, action: String) {
        this.eventManager.broadcast({ name: 'invoiceListModification', content: {
            action: action,
            content: result
        }});

        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackStudentById(index: number, item: Student) {
        return item.id;
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-invoice-popup',
    template: ''
})
export class InvoicePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private invoicePopupService: InvoicePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.invoicePopupService
                    .open(InvoiceDialogComponent as Component, params['id']);
            }  else if (params['paymentId']) {
                this.modalRef = this.invoicePopupService
                    .open(InvoiceDialogComponent as Component, null, params['paymentId']);
            } else {
                this.modalRef = this.invoicePopupService
                    .open(InvoiceDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice/invoice-dialog.component.ts